import { Input, InputRef } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { EpicIcon } from '../../../../assets/CustomIcons/EpicIcon';
import { queryClient } from '../../../../queryClient';
import { useUpdateEpicMutation } from '../../../../serverState/epics';
import { Epic } from '../../../../types/Epic';

export const EpicHeader = ({ epic, ...rest }: { epic: Epic } | any) => {
  const [isEditing, setisEditing] = useState(false);
  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, [isEditing]);

  const updateEpicMutation = useUpdateEpicMutation();

  const handleUpdateEpic = (newName: string) => {
    if (!newName.trim()) {
      setisEditing(false);
      setformValue(epic?.title);
      return;
    }
    updateEpicMutation.mutate(
      {
        workspaceId: epic.workspaceId,
        epicId: epic.id,
        epicName: newName,
      },
      {
        onSuccess: (data) => {
          queryClient.setQueryData(['epics', epic.workspaceId], (oldData: any) => {
            // TODO: Check how this works if it's lookingl ike a json type value in the logs...
            return oldData.map((p: Epic) => {
              if (p.id === epic.id) {
                return data;
              }
              return p;
            });
          });

          setisEditing(false);
        },
      }
    );
  };
  const [formValue, setformValue] = useState(epic?.title);

  if (isEditing && epic) {
    return (
      <Input
        epic-name-input-id={epic.id}
        className="h-5"
        // size='middle'
        onClick={(event) => {
          event.stopPropagation();
        }}
        ref={inputRef}
        value={formValue}
        onChange={(e) => {
          setformValue(e.target.value);
        }}
        onPressEnter={(e) => {
          const newValue = e.target.value;
          handleUpdateEpic(newValue);
          e.stopPropagation();
        }}
        onBlur={(e) => {
          const newValue = e.target.value;
          handleUpdateEpic(newValue);
          e.stopPropagation();
        }}
        onKeyDown={(e) => {
          if (e.key === 'Escape' || e.keyCode === 27) {
            setisEditing(false);
            setformValue(epic?.title);
            e.stopPropagation();
          }
        }}
      />
    );
  }

  return (
    <div className="flex items-center gap-1.5">
      <div className="h-[21px] w-[21px] ml-1 flex items-center justify-center text-white bg-purple-500 rounded outline outline-purple-300 cursor-default">
        <EpicIcon className="" />
      </div>
      <div
        {...rest}
        className="text-brand-grey-dark text-base font-semibold leading-tight epicSectionHeader pl-1 pr-1 w-fit rounded cursor-text text-ellipsis line-clamp-1"
        onClick={(event) => {
          event.stopPropagation();
          setisEditing(true);
        }}
        epic-name-id={epic?.id || -1}
      >
        {epic?.title || 'No Epic Assigned'}
      </div>
    </div>
  );
};
